import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./pressure.css";

import { Link } from "react-router-dom";
export default function PressureServiceView() {
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 700,
    pauseOnHover: false,
  };

  return (
    <>
       <Header />

      <main className="prs" id="content">
        {/* ===== HERO avec slider ===== */}
        <section className="prs-hero">
          <div className="prs-hero__text">
            <h1>Appareils à pression</h1>
            <p>
              Inspection, contrôle et suivi réglementaire des équipements sous pression
              afin de garantir la sécurité, la conformité légale et la performance
              de vos installations industrielles.
            </p>
            <a href="#contact" className="btn-primary">
              Demander un devis
            </a>
          </div>

          <div className="prs-hero__slider" aria-label="galerie d’images">
            <Slider {...sliderSettings}>
              <div><img src="/images/pression/1.jpg" alt="Inspection générateur vapeur" /></div>
              <div><img src="/images/pression/2.jpg" alt="Épreuve hydraulique" /></div>
              <div><img src="/images/pression/3.jpg" alt="Réservoir sous pression" /></div>
            </Slider>
          </div>
        </section>

        {/* ===== CONTENU DÉTAILLÉ ===== */}
        <section className="prs-grid">
          <article>
            <h2>Pourquoi le contrôle&nbsp;?</h2>
            <ul>
              <li>Prévenir les explosions dues à l’énergie emmagasinée sous pression.</li>
              <li>Protéger les vies humaines contre les blessures, brûlures ou pertes.</li>
              <li>Garantir la disponibilité et la productivité des installations.</li>
            </ul>
          </article>

          <article>
            <h2>Textes rendant obligatoire le contrôle</h2>
            <ul>
              <li>Dahir du 22 juillet 1953 réglementant les appareils à vapeur.</li>
              <li>Dahir du 12 janvier 1955 réglementant les appareils à gaz.</li>
              <li>Code du travail.</li>
              <li>Arrêtés et circulaires ministériels.</li>
            </ul>
          </article>

          <article>
            <h2>Autorité compétente</h2>
            <p>Ministère de l’Énergie et des Mines.</p>
          </article>

          <article>
            <h2>Appareils soumis à la réglementation</h2>
            <ul>
              <li>Appareils à vapeur : P ≥ 0,33 bar, T ≥ 100 °C, V ≥ 25 l (générateurs) et ≥ 100 l (récipients).</li>
              <li>Appareils à gaz : P ≥ 4 bar et P (bar) × V (litre) ≥ 80.</li>
            </ul>
          </article>

          <article>
            <h2>Obligations réglementaires</h2>
            <ul>
              <li>Appareils à vapeur : visite interne annuelle, visite externe annuelle, épreuve hydraulique décennale.</li>
              <li>Appareils à gaz : périodicité selon contenance (<em>nous consulter</em>).</li>
            </ul>
          </article>

          <article>
            <h2>Documents à exiger à l’achat</h2>
            <p><strong>Appareils construits au Maroc :</strong></p>
            <ul>
              <li>Plan d’ensemble détaillé.</li>
              <li>Note de calcul avec coefficient de soudure.</li>
              <li>État descriptif.</li>
            </ul>
            <p><strong>Appareils importés :</strong> autres documents à demander (<a href="#contact">nous contacter</a>).</p>
          </article>

          
        </section>

        {/* ===== CTA ===== */}
        <div className="prs-btns">
          <Link to="/#contact" className="btn-primary">faire une consultation</Link>
        </div>
      </main>

      {/* ====== FOOTER global ====== */}
      <Footer />
    </>
  );
}
